export const screenSizes = {
  extraWideScreen: 1750,
  wideScreen: 1200,
  desktop: 992,
  tablet: 768,
  phone: 0 /* 320 */
};

export const theme = {
  icons: {
    auctionOutBid: '"\\e99c"',
    phone: '"\\e942"',
    facebook: '"\\e901"',
    twitter: '"\\e906"',
    linkedIn: '"\\e902"',
    x: '"\\e904"',
    arrow: '"\\e905"',
    check: '"\\e91a"',
    excel: '"\\e900"',
    info: '"\\e958"'
  },
  fonts: {
    medium: 'ProximaNova-Medium',
    regular: "'ProximaNova-Regular', sans-serif",
    bold: 'ProximaNova-Bold',
    semiBold: 'ProximaNova-SemiBold',
    light: 'ProximaNova-Light'
  },
  colors: {
    white0: '#ffffff',
    red10: '#fff1f1',
    red20: '#FFE2E5',
    red50: '#C10230',
    red60: '#b80027',
    red65: '#d31145',
    red70: '#9b3965',
    red80: '#862C55',
    green50: '#04bb80',
    gray100: '#000000',
    gray90: '#434343',
    gray80: '#5A595980',
    gray75: '#979797',
    gray70: '#737373',
    gray60: '#9b8f8f',
    gray50: '#cecece',
    gray30: '#F0F0F0',
    gray10: '#f9f9f9',
    gray20: '#f7f7f7',
    gray40: '#9D9B9B',
    gray7: '#e4e4e4',
    gray6: '#a4a5a5',
    gray5: '#d9d9d9',
    gray4: '#f2f2f2',
    gray41: '#e3e3e3',
    gray42: '#d6d6d6',
    gray0: '#FFFFFF',
    blue75: '#00386d',
    blue60: '#276aa9',
    blue50: '#0078a0',
    blue55: '#008bb9',
    blue25: '#009dd3',
    blue5: '#def1f8',
    blue4: '#D6E5F746',
    green35: '#00ba88',
    green15: '#D9F5ED',
    EndedBuyerLost: '#979797',
    EndedBuyerWon: '#04bb80',
    EndedSellerSold: '#04bb80',
    backgroundMenuColor: '#f8f3f3',
    footerBackground: '#f8f3f3',
    backgroundCatalogMenuColor: '#f1e8cf',
    borderCatalogColor: '#cda120',
    menuFontColor: '#434343',
    activeMenuColor: '#7d1f49',
    light_green: 'rgba(0, 176, 80, 1)',
    modalOverlay: 'rgba(230, 230, 230, 0.7)', // hex makes problems in edge
    focusShadowSiteBlue: 'rgba(0, 185, 247, 0.5)',
    focusShadowSiteGrey: 'rgba(112, 112, 112, 0.2)',
    fontColor: '#5a5959',
    buttonsColor: '#8F8E8E',
    mainMenuActiveLine: '#CB0000',
    backgroundJewelryCards: '#F9F9F9',
    mainMenuHoverLine: '#CAC9C9',
    palePink: '#F8F3F3',
    inputBorderGrey: '#CCD6E2',
    inputBackgroundGrey: '#FDFDFD'
  },
  catalogColors: {
    white0: '#ffffff',
    red10: '#fff1f1',
    red20: '#FFE2E5',
    red50: '#C10230',
    red60: '#b80027',
    red65: '#d31145',
    red70: '#9b3965',
    red80: '#862C55',
    green50: '#04bb80',
    gray100: '#000000',
    gray90: '#434343',
    gray80: '#5A595980',
    gray75: '#979797',
    gray70: '#737373',
    gray60: '#9b8f8f',
    gray50: '#cecece',
    gray30: '#F0F0F0',
    gray10: '#f9f9f9',
    gray20: '#f7f7f7',
    gray7: '#e4e4e4',
    gray6: '#a4a5a5',
    gray5: '#d9d9d9',
    gray4: '#f2f2f2',
    gray41: '#e3e3e3',
    gray42: '#d6d6d6',
    gray0: '#FFFFFF',
    blue75: '#00386d',
    blue60: '#276aa9',
    blue50: '#0078a0',
    blue55: '#008bb9',
    blue25: '#009dd3',
    blue5: '#def1f8',
    blue4: '#D6E5F746',
    green35: '#00ba88',
    green15: '#D9F5ED',
    backgroundMenuColor: '#fff',
    footerBackground: '#F4F8FD',
    backgroundCatalogMenuColor: '#f1e8cf',
    borderCatalogColor: '#cda120',
    menuFontColor: '#434343',
    activeMenuColor: '#00386E',
    light_green: 'rgba(0, 176, 80, 1)',
    modalOverlay: 'rgba(230, 230, 230, 0.7)', // hex makes problems in edge
    focusShadowSiteBlue: 'rgba(0, 185, 247, 0.5)',
    focusShadowSiteGrey: 'rgba(112, 112, 112, 0.2)',
    fontColor: '#5a5959',
    buttonsColor: '#8F8E8E',
    mainMenuActiveLine: '#CB0000',
    backgroundJewelryCards: '#F9F9F9',
    mainMenuHoverLine: '#CAC9C9',
    palePink: '#F8F3F3',
    inputBorderGrey: '#CCD6E2',
    inputBackgroundGrey: '#FDFDFD'
  },
  mobile: '1024px',
  lightShadow: '#868686 0px 0.8px 1.4px 0.4px',
  basicShadow: '0 0.5px 3px 0 rgba(0, 0, 0, 0.02), 0 0.5px 1px 0 rgba(0, 0, 0, 0.03)',
  tableLineShadow: 'inset 0 -1px 0 0 rgba(0, 0, 0, 0.1)'
};

export const color = colorString => {
  if (CONFIG && CONFIG.AUCTION_TYPE === 'collection') {
    return theme.catalogColors[colorString];
  } else {
    return theme.colors[colorString];
  }
};

// export const color = colorString => theme.catalogColors[colorString];

export const isMobile = window.matchMedia(`(max-width:${theme.mobile})`).matches;
// export const isMobile = false;
